/** @jsx h */
import { h } from 'preact'
import './progress.css'
import NumberDial from '../number-dial'
import transitionIn from '../transition-in'

export default transitionIn(
  ({
    raised,
    goal,
    className,
    size = 120,
    strokeWidth = 12,
    firstRender,
    textSize = 'big'
  }) => {
    const number = firstRender ? 0 : Math.floor(raised / goal * 100)
    const adjustedNumber = number > 100 ? 100 : number

    const radius = size / 2 - strokeWidth / 2
    const circumference = 2 * Math.PI * radius

    const progress = adjustedNumber / 100
    const strokeDashoffset = circumference * (1 - progress)
    const strokeDasharray = 2 * Math.PI * radius

    const halfSize = size / 2

    const textHeight = textSize === 'big' ? '40' : '26'
    const textClass = textSize === 'big' ? 'f2' : 'f3'

    return (
      <div className='relative flex items-center content-center justify-center'>
        <div
          className='absolute tc w-100'
          style={{
            top: size / 2 - textHeight / 2 + 'px',
            left: '50%',
            marginLeft: '-50%'
          }}
        >
          <NumberDial
            height={textHeight}
            className={`dib dark-gray ${textClass} fw6`}
          >{`${number}%`}</NumberDial>
        </div>
        <svg
          className='progress'
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
        >
          <circle
            cx={halfSize}
            cy={halfSize}
            r={radius}
            fill='none'
            stroke='#e6e6e6'
            stroke-width={strokeWidth}
          />
          <circle
            className='progress__value'
            style={{
              strokeDashoffset,
              strokeDasharray,
              strokeLinecap: 'round'
            }}
            cx={halfSize}
            cy={halfSize}
            r={radius}
            fill='none'
            stroke='#00CDA1'
            stroke-width={strokeWidth}
          />
        </svg>
      </div>
    )
  }
)
